import React, { useState, useContext } from 'react'
import { AiOutlineUser } from "react-icons/ai";
import { PiShoppingCartSimple } from "react-icons/pi";
import { IoSearchOutline } from "react-icons/io5";
import { IoMenu } from "react-icons/io5";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { CategoryMenu } from '../components/CategoryMenu';
import { CartContext } from "../../contexts/CartContext";

export const Nabvar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cartItems, removeFromCart, clearCart } = useContext(CartContext);

  // Función para alternar el estado del menú
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className='flex-container bg_201CE5 color_white font-family-montserrat justify-content div-nohidden'
        style={{ paddingTop: '10px'}}
      >
        <div className='flex-item flex-start txt-start flex-container div-nohidden'>
          {menuOpen ? (
            <IoMdClose size={32} onClick={closeMenu} className="div-nohidden pointer open-icon-mobile" />
          ) : (
            <IoMenu size={30} onClick={toggleMenu} className="div-nohidden flex-item pointer open-icon-mobile" />
          )}
          <IoSearchOutline size={32} className='flex-item div-nohidden' />
        </div>
        <div className='flex-item txt-center font20 div-nohidden'>
          <Link to="/" className="text-decoration-none">
            <img
              src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=LOGO%20COMPURED%202-04%20(1).webp&version_id=null"
              alt='Logo'
              width='100px'
            // height='100px'
            />
          </Link>
        </div>
        <div className='flex-item flex-end flex-container mr-10'>
          <AiOutlineUser size={25} className='flex-item' />
          <div className="position-relative div-nohidden">
            <Link to="carro-compras">
              <PiShoppingCartSimple size={28} color="#fff" className="icon-cart-nav" />
              <div
                className="flex-container flex-center font12v2 txt-semibold 
                  font-family-montserrat position-absolute item-count">
                {
                  (cartItems.length > 0) ? cartItems.length : '0'
                }
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className={`div-nohidden menu ${menuOpen ? 'fade-in' : 'fade-out'}`}>
        {menuOpen && <CategoryMenu closeMenu={closeMenu} fullScreen={true} className='div-nohidden' />}
      </div>
    </>
  );
};